/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RoleDto } from './RoleDto';
import {
    RoleDtoFromJSON,
    RoleDtoFromJSONTyped,
    RoleDtoToJSON,
} from './RoleDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfRoleDto
 */
export interface ODataPostProcessedResultsOfRoleDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfRoleDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof ODataPostProcessedResultsOfRoleDto
     */
    value?: Array<RoleDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfRoleDto
     */
    $type?: ODataPostProcessedResultsOfRoleDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfRoleDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfRoleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedAuthorizationRolesDtoRoleDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.Authorization.Roles.Dto.RoleDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfRoleDtoTypeEnum = typeof ODataPostProcessedResultsOfRoleDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfRoleDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfRoleDto interface.
 */
export function instanceOfODataPostProcessedResultsOfRoleDto(value?: unknown): value is ODataPostProcessedResultsOfRoleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfRoleDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfRoleDtoFromJSON(json: any): ODataPostProcessedResultsOfRoleDto {
    return ODataPostProcessedResultsOfRoleDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfRoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(RoleDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfRoleDtoToJSON(value?: ODataPostProcessedResultsOfRoleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(RoleDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

